import React from 'react';
import { Redirect } from 'react-router-dom';

const ParticipantDashboard = () => {
    return <Redirect to="/investor/wallet" />;
};

export default ParticipantDashboard;
